import { processFilters as processFiltersDiagram} from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & { importedFilters }

export const processFilters = ({ importedFilters ,eventEmitter }: Props) => {
    processFiltersDiagram(importedFilters);
    eventEmitter.emit(Event.applyFilter);
    if (apiProvider.getActiveAction() ==='process_miner') apiProvider.rebuildPVDiagram('processSlicers');
    eventEmitter.emit(Event.updateGaugeMetrics);
};


